import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

const articleImages: Record<string, string> = {
  '1': 'https://readdy.ai/api/search-image?query=Historical%20academic%20library%20with%20vintage%20books%20and%20warm%20amber%20lighting%2C%20sophisticated%20scholarly%20atmosphere%2C%20abstract%20historical%20timeline%20elements%2C%20editorial%20photography%20style%2C%20soft%20natural%20light%20through%20windows%2C%20warm%20cream%20and%20terracotta%20tones&width=800&height=450&seq=article-card-1&orientation=landscape',
  '2': 'https://readdy.ai/api/search-image?query=Educational%20dictionary%20and%20terminology%20concept%20art%2C%20warm%20amber%20and%20cream%20color%20palette%2C%20abstract%20letterforms%20and%20symbols%20floating%20in%20soft%20light%2C%20clean%20modern%20editorial%20design%2C%20intellectual%20atmosphere&width=800&height=450&seq=article-card-2&orientation=landscape',
  '3': 'https://readdy.ai/api/search-image?query=Abstract%20artistic%20representation%20of%20role%20dynamics%20and%20identity%20spectrum%2C%20warm%20rose%20and%20terracotta%20gradient%2C%20flowing%20organic%20shapes%20merging%20and%20separating%2C%20modern%20minimalist%20design%2C%20soft%20ethereal%20lighting&width=800&height=450&seq=article-card-3&orientation=landscape',
  '4': 'https://readdy.ai/api/search-image?query=Minimalist%20artistic%20representation%20of%20textile%20art%20and%20rope%20craft%2C%20warm%20cream%20and%20amber%20tones%2C%20abstract%20flowing%20lines%2C%20soft%20natural%20lighting%2C%20elegant%20composition%2C%20editorial%20quality&width=800&height=450&seq=article-card-4&orientation=landscape',
  '5': 'https://readdy.ai/api/search-image?query=Abstract%20sensory%20experience%20artwork%2C%20warm%20amber%20and%20rose%20tones%20with%20soft%20gradients%2C%20flowing%20textures%20representing%20touch%20and%20sensation%2C%20minimalist%20elegant%20composition%2C%20soft%20diffused%20lighting%2C%20editorial%20style&width=800&height=450&seq=article-card-5&orientation=landscape',
  '6': 'https://readdy.ai/api/search-image?query=Minimalist%20safety%20and%20ethics%20concept%20art%2C%20warm%20sage%20green%20and%20cream%20tones%2C%20abstract%20protective%20geometric%20shapes%2C%20clean%20professional%20aesthetic%2C%20soft%20natural%20lighting%2C%20editorial%20quality%20composition&width=800&height=450&seq=article-card-6&orientation=landscape',
};

export default function FeaturedArticles() {
  const featured = articles.slice(0, 6);

  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-100/50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-12">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              精选文章
            </h2>
            <p className="text-foreground-600 text-sm md:text-base">
              由专业编辑团队精心编写，确保内容的准确性与可读性
            </p>
          </div>
          <Link
            to="/category/sm-basics"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 font-medium whitespace-nowrap hover:text-primary-600 transition-colors cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {featured.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group block bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-video overflow-hidden">
                <img
                  src={articleImages[article.id]}
                  alt={article.title}
                  title={`${article.title} - SM专业指南`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 mb-3">
                  <span className="text-xs px-2.5 py-1 rounded-md bg-secondary-100 text-secondary-700 font-medium">
                    {article.category}
                  </span>
                  <span className="text-xs text-foreground-500">{article.readTime}阅读</span>
                </div>
                <h3 className="text-base font-semibold text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors leading-snug">
                  {article.title}
                </h3>
                <p className="text-foreground-600 text-sm line-clamp-2 leading-relaxed">
                  {article.excerpt}
                </p>
                <div className="mt-4 flex items-center justify-between">
                  <span className="text-xs text-foreground-500">{article.date}</span>
                  <span className="flex items-center gap-1 text-sm text-primary-500 font-medium opacity-0 group-hover:opacity-100 transition-opacity">
                    阅读全文
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/sm-basics"
            className="inline-flex items-center gap-1 text-sm text-primary-500 font-medium hover:text-primary-600 transition-colors cursor-pointer"
          >
            查看全部文章
            <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}